import { useDispatch, useSelector } from 'react-redux'
import './total.scss'
import { useEffect, useState } from 'react'
import { getFacultyDashboardPayment } from '../../../store/builders/faculty/faculty-dashboard.builder'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'

function TotalFees() {
  const dispatch = useDispatch()
  const facultyId = useSelector((state) => state?.auth?.user?.result?.facultyId)
  const paymentData = useSelector((store) => store.facultyDashboard.facultyDashboardPayment)
  
   const [isLocked, setIsLocked] = useState(true)
  useEffect(() => {
    dispatch(getFacultyDashboardPayment(facultyId))
    return () => dispatch({ type: 'facultyDashboard/clearExtraReducers' })
  }, [])

    const toggleLock = () => {
      setIsLocked(!isLocked)
    }

  return (
    <div className='total-fees-wrapper'>
      <p>Payment History</p>
      {isLocked && <LockOutlinedIcon className='faculty-profile-lock' onClick={toggleLock} />}
      <div className={`fees-list-wrapper ${!isLocked ? '' : 'blur'}`}>
        {paymentData?.monthlyBilling?.map((row, index) => {
          return (
            <div className='fees-installment' key={index}>
              {index !== 0 && <div className='separatorLine'></div>}
              <div className='installment-row'>
                <p>{row && row?.month}</p>
                <div className='details'>
                  <p>
                    <span>{row?.lectureCount}</span> Total Lectures
                  </p>{' '}
                  <div className='hr-line'></div>
                  <p>
                    <span>{row?.totalHours.toFixed()}</span> Total Hours
                  </p>{' '}
                  <div className='hr-line'></div>
                  <p>
                    <span>₹ {Number(row?.totalAmount).toLocaleString('en-US')}</span> Payment
                  </p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default TotalFees
